import gql from 'graphql-tag';

export default gql`
  mutation pingUser($input: PingUserInput!) {
    pingUser(input: $input) {
      userId
    }
  }
`;
